var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoveCard = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.75 11C7.75 10.5858 8.08579 10.25 8.5 10.25H11.6893L10.9697 9.53033C10.6768 9.23744 10.6768 8.76256 10.9697 8.46967C11.2626 8.17678 11.7374 8.17678 12.0303 8.46967L14.0303 10.4697C14.3232 10.7626 14.3232 11.2374 14.0303 11.5303L12.0303 13.5303C11.7374 13.8232 11.2626 13.8232 10.9697 13.5303C10.6768 13.2374 10.6768 12.7626 10.9697 12.4697L11.6894 11.75H8.5C8.08579 11.75 7.75 11.4142 7.75 11Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.25 4C1.25 3.0335 2.0335 2.25 3 2.25H13C13.9665 2.25 14.75 3.0335 14.75 4V6H13.25V4C13.25 3.86193 13.1381 3.75 13 3.75H3C2.86193 3.75 2.75 3.86193 2.75 4V12C2.75 12.1381 2.86193 12.25 3 12.25H6V13.75H3C2.0335 13.75 1.25 12.9665 1.25 12V4Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoveCard);
export default ForwardRef;